import React, { useContext } from "react";
import { Bar } from "react-chartjs-2";
import domainService from "../../services/domainService";
import { green, darkGrey } from "../../shared/colours";
import { ThemeModeContext } from "../../shared/Theme";
import Chart from 'chart.js/auto';

const ServiceLocationGraph = (props) => {

	const themeModeContext = useContext(ThemeModeContext);
	
	const options = {
		indexAxis: "y",
		plugins: {
			legend: {
				display: false
			}
		},
		scales: {
			x: {
				ticks: {
					beginAtZero: true,
					color: themeModeContext.themeMode === "light"? darkGrey : green,
					font: {
						size: 10
					}
				}
			},
			y: {
				ticks: {
					color: themeModeContext.themeMode === "light"? darkGrey : green,
					font: {
						size: 10
					}
				}
			}
		},
		maintainAspectRatio: false
	};
	
	const getData = () => {
		const serviceCounts = {};
		const services = domainService.companyServices;
		for (let i in services) {
			if (!serviceCounts.hasOwnProperty(services[i].iso_code)) {
				serviceCounts[services[i].iso_code] = 0;
			}
			serviceCounts[services[i].iso_code] += 1;
		}
		
		const keys = Object.keys(serviceCounts);
		let sortableList = [];
		for (let i in keys) {
			sortableList.push({ location: keys[i], total: serviceCounts[keys[i]] });
		}
		sortableList.sort((a, b) => { return b.total - a.total; });
		
		const labels = [];
		const counts = [];
		for (let i = 0; i < 5; i++) {
			if (sortableList.length <= i) continue;
			labels.push(sortableList[i].location);
			counts.push(sortableList[i].total);
		}
		
		const data = {
			labels: labels,
			datasets: [{
				label: "Locations",
				backgroundColor: "#ff03ed",
				data: counts,
				fill: true,
			}]
		};
		
		return data;
	};
	
	return (
		<Bar data={getData()} options={options} width="100%" height="100%"/>
	);

}

export default ServiceLocationGraph;